import IdentityNumber, { type IdentityNumberFieldProps } from '../../../components/fields/IdentityNumberField';
import { InputContainer } from './shared';

const InputNumberField = (props: IdentityNumberFieldProps) => (
    <InputContainer>
        <IdentityNumber {...props} />
    </InputContainer>
);

export default InputNumberField;
